import { Accordion, ScrollArea, SidebarGroup, SidebarGroupContent, SidebarMenu } from '@ibsys/kit';
import { FC, useMemo } from 'react';
import { RouteConfig } from '@/shared/lib/ts-router';
import { AppSidebarGroup } from './AppSidebarGroup';
import { AppSidebarItem } from './AppSidebarItem';
import { cn } from '@/shared/lib';
import { calcGroupName, isActiveNested } from '@/widgets/MainLayout/model/utils';
import { useLocation } from 'react-router-dom';

type Props = {
  menuItems: RouteConfig[];
  className?: string;
};

export const AppSidebaItems: FC<Props> = (props) => {
  const { menuItems, className } = props;
  const { pathname } = useLocation();
  const isRootPath = pathname === '/';

  const defaultGroupName = useMemo(() => {
    const filtered = menuItems?.filter((item) => !!item.navbar || item.type === 'group') ?? [];
    const activeIndex = filtered.findIndex(
      (route) => (route.type === 'group' || !route.path) && isActiveNested(route, pathname),
    );
    return activeIndex >= 0 ? calcGroupName(`group_${activeIndex}`) : '';
  }, [menuItems, pathname]);

  return (
    <SidebarMenu className={cn('list-none', className)}>
      <SidebarGroup className={'px-0'}>
        <SidebarGroupContent className="gap-1 flex flex-col">
          {/* Иначе обёртка содержимого тянется по самому длинному пункту: подпись из данных
              не усекается, а даёт меню горизонтальную прокрутку. */}
          <ScrollArea orientation="vertical" className="[&>[data-radix-scroll-area-viewport]>div]:!block">
            <Accordion type={'multiple'} defaultValue={[defaultGroupName]} key={isRootPath.toString()}>
              {menuItems
                ?.filter((item) => !!item.navbar || item.type === 'group')
                .map((route, index) =>
                  route.type === 'group' || !route.path ? (
                    <AppSidebarGroup
                      route={route}
                      key={route.path || index.toString()}
                      name={calcGroupName(`group_${index}`)}
                      isRoot
                    />
                  ) : (
                    <AppSidebarItem route={route} key={index.toString()} isRoot />
                  ),
                )}
            </Accordion>
          </ScrollArea>
        </SidebarGroupContent>
      </SidebarGroup>
    </SidebarMenu>
  );
};
